import React, { useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';

export default function PFDropdown({
  value,
  name,
  onChange,
  options,
  optionLabel,
  placeholder,
  filter,
  className,
  optionValue,
  disabled,
  appendTo,
  showClear,
  onKeyPress,
  onKeyUp,
  onKeyDown,
  filterValue,
  onFilterChange,
  onBlur,
  pt,
  inputId,
  ...props
}) {
  const onKeyDownRef = useRef(onKeyDown);
  onKeyDownRef.current = onKeyDown;

  useEffect(() => {
    if (!inputId) {
      return undefined;
    }

    const attachListener = () => {
      const element = document.getElementById(inputId);

      if (!element) {
        return null;
      }

      const handler = event => {
        onKeyDownRef.current?.(event);
      };

      element.addEventListener('keydown', handler, true);

      return () => element.removeEventListener('keydown', handler, true);
    };

    let cleanup = attachListener();

    if (!cleanup) {
      const timer = setTimeout(() => {
        cleanup = attachListener();
      }, 0);

      return () => {
        clearTimeout(timer);
        cleanup?.();
      };
    }

    return cleanup;
  }, [inputId]);

  return (
    <Dropdown
      {...props}
      inputId={inputId}
      value={value || ''}
      name={name || ''}
      onChange={e => onChange(name, e.value)}
      options={options || []}
      optionLabel={optionLabel || ''}
      optionValue={optionValue || ''}
      placeholder={placeholder || ''}
      filter={filter || false}
      className={`w-full p-inputtext-sm ${className || ''}`}
      disabled={disabled || false}
      appendTo={appendTo || null}
      virtualScrollerOptions={false}
      showClear={showClear || false}
      onKeyPress={onKeyPress}
      onKeyUp={onKeyUp}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      filterValue={filterValue || ''}
      onFilterChange={onFilterChange ? onFilterChange : () => {}}
      resetFilterOnHide={true}
      pt={pt}
      itemTemplate={
        props.itemTemplate
          ? props.itemTemplate
          : option => (
              <div
                style={{
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  lineHeight: '1.4rem',
                  padding: '6px 10px',
                }}
              >
                {option?.[optionLabel]}
              </div>
            )
      }
    />
  );
}
